module.exports = {"469030100":"营根镇","469030101":"湾岭镇","469030102":"黎母山镇","469030103":"和平镇","469030104":"长征镇","469030105":"红毛镇","469030106":"中平镇","469030200":"吊罗山乡","469030201":"上安乡","469030202":"什运乡","469030500":"海南热带雨林国家公园管理局黎母山分局"}


//////////////////
// WEBPACK FOOTER
// ./src/town/469030.json
// module id = 2340
// module chunks = 0